import { LVGPdata } from "./LeVIVO GreenfieldPark/Data_LVGP";
import { LVLPdata } from "./LeVIVO LaPrairie/Data_LVLP";
import { LVLO1data } from "./LeVIVO LG1/Data_LVLO1";
import { LVLO2data } from "./LeVIVO LG2/Data_LVLO2";
import { LVSHdata } from "./LeVIVO Sherbrooke/Data_LVSH";
import { L144data } from "./Local 144/Data_L144";
import { ARCANDdata } from "./Arcand/Data_Arcand";
import { LQOP1data } from "./Le Quartier OVIV/Phases/Le Boréal/Data_LQOP1";

//type
export const project_type = {
  fr: {
    commercial: 'Commercial',
    residential: 'Résidentiel'
  },
  en: {
    commercial: 'Commercial',
    residential: 'Residential'
  }
}

// Individual
export const projects = {
  fr: {
    1: ARCANDdata.fr,
    2: LVGPdata.fr,
    3: LVLPdata.fr,
    4: LVLO1data.fr,
    5: LVLO2data.fr,
    6: LVSHdata.fr,
    7: L144data.fr,
    8: LQOP1data.fr
  },
  en: {
    1: ARCANDdata.en,
    2: LVGPdata.en,
    3: LVLPdata.en,
    4: LVLO1data.en,
    5: LVLO2data.en,
    6: LVSHdata.en,
    7: L144data.en,
    8: LQOP1data.en
  }
}

//ARRAY
export const projectsData = {
  fr: [
    LVGPdata.fr,
    LVLO1data.fr,
    LVLO2data.fr,
    LVSHdata.fr,
    LVLPdata.fr,
    L144data.fr,
    ARCANDdata.fr,
    LQOP1data.fr
  ],
  en: [
    LVGPdata.en,
    LVLO1data.en,
    LVLO2data.en,
    LVSHdata.en,
    LVLPdata.en,
    L144data.en,
    ARCANDdata.en,
    LQOP1data.en
  ]
};
